import { API } from '@/shared/api/modules';
import type { GetTotalStaffRequestDto } from '@/shared/api/modules/staff';
import { queryOptions } from '@tanstack/react-query';

export const getTotalStaffQueryOptions = (params: GetTotalStaffRequestDto) =>
  queryOptions({
    queryKey: ['total-staff', params],
    queryFn: async ({ signal }) => {
      const response = await API.staff.getTotalStaff(params, {
        signal,
      });

      return response;
    },
    enabled: !!params.from && !!params.to,
  });
